// extracted by mini-css-extract-plugin
module.exports = {"root":"HeadlineComponent_root__NZSZr","white":"HeadlineComponent_white__2A2B7","pretitle":"HeadlineComponent_pretitle__XOlMh","description":"HeadlineComponent_description__lhVVH"};